interface Array<T> {
    remove(item: T): void
    sum(predicate: (item: T) => number): number
    distinct(): Array<T>
}

Array.prototype.remove = function(item) {
    return this.splice(this.indexOf(item), 1)
}

Array.prototype.sum = function(predicate: (item: any) => number) {
    return this.map(predicate).reduce((a, b) => a + b, 0)
}

Array.prototype.distinct = function() {
    return this.filter((x, y, z) => z.indexOf(x) === y)
}
